import React, { useState } from 'react';
import { CheckCircle, RefreshCw } from 'lucide-react';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../../ui/dialog';
import { MailAwayFilePicker, useMailAwayFiles } from './MailAwayFilePicker';

/** Tax-style "Mark Response Received" modal: response document required (≤3 files / 30 MB). */
export const MailAwayResponseModal = ({ open, targetName, loading, onConfirm, onClose, testIdPrefix = 'mailaway' }) => {
  const [notes, setNotes] = useState('');
  const [error, setError] = useState('');
  const zone = useMailAwayFiles({ onAccepted: () => setError('') });
  const files = Array.isArray(zone.file) ? zone.file : [];

  const submit = () => {
    if (files.length === 0) { setError('Response document is required. Please upload the response file.'); return; }
    onConfirm(notes.trim(), files);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && !loading) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid={`${testIdPrefix}-response-modal`}>
        <div className="flex items-center gap-3">
          <div className="p-2 bg-green-100 rounded-full"><CheckCircle size={20} className="text-green-600" /></div>
          <DialogTitle className="text-lg font-semibold text-gray-900">Mark Response Received</DialogTitle>
        </div>
        <DialogDescription className="text-gray-600">Mark response received for <strong>{targetName}</strong>?</DialogDescription>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Response Document <span className="text-red-500">*</span></label>
          <MailAwayFilePicker zone={zone} error={error} onClearError={() => setError('')} testIdPrefix={testIdPrefix} />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Notes (Optional)</label>
          <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            placeholder="Notes about the response..." data-testid={`${testIdPrefix}-response-notes`} />
        </div>
        <div className="flex items-center gap-3">
          <Button onClick={submit} disabled={loading} className="flex-1 bg-green-600 hover:bg-green-700" data-testid={`${testIdPrefix}-response-confirm`}>
            {loading ? <><RefreshCw size={16} className="mr-2 animate-spin" />Saving...</> : <><CheckCircle size={16} className="mr-2" />Mark Received</>}
          </Button>
          <Button variant="outline" onClick={onClose} disabled={loading} data-testid={`${testIdPrefix}-response-cancel`}>Cancel</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MailAwayResponseModal;
